<script setup lang="ts">
import { computed } from 'vue'

import ContentView from './ContentView.vue'
import SalesRepContactButton from '@/components/common/SalesRepContactButton.vue'
import ArrotexLogo from '@/components/icons/ArrotexLogo.vue'
import ArrotexOffersWidget from '@/components/widgets/arrotex-offers-widget/ArrotexOffersWidget.vue'
import BrilintaLogo from '@/components/icons/BrilintaLogo.vue'

import { useThemeStore } from '@/stores'
import type { Product } from '@/components/widgets/arrotex-offers-widget/ArrotexOfferPoduct.vue'

const themeStore = useThemeStore()
const { themeColors } = themeStore


const newProducts: Product[] = [
  {
    title: 'Duodart Doublets',
    subTitle: 'rivaroxaban',
    bannerText: 'LAUNCH',
    bannerSubTextBold: '4 Weeks',
    bannerSubTextRegular: 'Free Stock',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab dolore magna aliqua. Ut enim ad minim veniam.',
    productImage: 'ARX-Duodart Doubluts.webp',
    orientation: 'column'
  },
  {
    title: 'Darunavir Juno',
    subTitle: 'rivaroxaban',
    bannerText: 'LAUNCH',
    bannerSubTextBold: '4 Weeks',
    bannerSubTextRegular: 'Free Stock',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab dolore magna aliqua. Ut enim ad minim veniam.',
    productImage: 'ARX-Darunavir.webp',
    orientation: 'column'
  },
  {
    title: 'Klarvanta',
    subTitle: 'amoxicillin; clavulanic acid 875/125mg',
    bannerText: 'LAUNCH',
    bannerSubTextBold: 'Free',
    bannerSubTextRegular: 'Sample',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab dolore magna aliqua. Ut enim ad minim veniam.',
    productImage: 'ARX-Klarvanta.webp',
    orientation: 'column'
  }
]

const promoProducts = computed<Product[]>(() => [
  {
    title: 'Melatonin Exclusive Deal',
    subTitle: 'For the attention of the pharmacist',
    bannerText: '15 + 25',
    bannerSubTextBold: 'Free',
    bannerSubTextRegular: 'Limited Offer',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab dolore magna aliqua. Ut enim ad minim veniam.',
    productImage: 'ARX-Melatonin.webp'
  },
  {
    title: 'Ticagrelor',
    subTitle: 'ticagrelor tablets',
    bannerText: 'SPECIAL',
    bannerSubTextBold: 'Patient Program',
    bannerSubTextRegular: 'Available',
    logo: BrilintaLogo,
    logoProps: { height: '3.75rem', width: '9.375rem', fill: themeColors.colorText },
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab dolore magna aliqua. Ut enim ad minim veniam.',
    productImage: 'ARX-Ticagrelor.webp'
  },
  {
    title: 'ARX-Rivaroxaban',
    subTitle: 'rivaroxaban',
    bannerText: '55% OFF',
    bannerSubTextBold: '4 Weeks',
    bannerSubTextRegular: 'Free Stock',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut lab dolore magna aliqua. Ut enim ad minim veniam.',
    productImage: 'ARX-Rivaroxaban.webp'
  }
])
</script>

<template>
  <ContentView>
    <template #top>
      <ArrotexLogo width="10.9375rem" height="3.125rem" :fill="themeColors.colorText" />
      <SalesRepContactButton label="Contact your Arrotex Rep" type="arrotex" />
    </template>
    <template #middle>
      <div class="offers-outer">
        <ArrotexOffersWidget :data="newProducts" background="dark" />
        <ArrotexOffersWidget :data="promoProducts" backgroundGlow="last" />
      </div>
    </template>
  </ContentView>
</template>

<style scoped>
.offers-outer {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 0.625rem;
  height: 100%;
  width: 100%;
  padding-block: 2.5%;
}
</style>
